// extracted by mini-css-extract-plugin
export default {"box":"Route_box__0O6FN","subjrxt":"Route_subjrxt__rKm4z","title":"Route_title__8Nz3k"};